"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import Image from "next/image";

export function LeaderboardSpotlightSection() {

  return (
    <section className="relative w-full bg-background py-12 md:py-16 lg:py-24 max-w-4xl mx-auto">
      <div className="w-full max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          {/* Left Column - Text Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-swapper-secondary mb-4 md:mb-6">
              Leaderboard
              <br />
              Spotlight
            </h2>
            <p className="text-base md:text-lg text-swapper-secondary/70 leading-relaxed mb-6 md:mb-8 max-w-xl">
              Find out who's leading the pack in the SwapperVerse! Our leaderboard showcases top members, their achievements, and sweet rewards. See your rank, compete with the best, and aim for bigger prizes.
            </p>
            <Link href="/leaderboard">
              <Button
                variant="primary"
                size="sm"
                className="bg-swapper-primary hover:bg-swapper-primary/90 text-white font-semibold rounded-xl transition-all duration-200 ease-out px-6 py-2 text-sm"
              >
                Leaderboard
              </Button>
            </Link>
          </div>

          {/* Right Column - Leaderboard Image */}
          <div className="relative w-full aspect-square max-w-md mx-auto">
            <Image
              src="/assets/landing/leaderboard-spotlight.png"
              alt="Leaderboard Spotlight"
              fill
              className="object-contain"
            />

            {/* Overlay Content - Positioned to match card in background */}
            <div className="absolute inset-0 flex items-end justify-center pb-[18%]">
              <div className="text-center space-y-0.5">
                {/* 1st Place Label */}
                <p className="text-xs font-medium" style={{ color: '#836FFF', opacity: 0.6 }}>
                  1st Place
                </p>

                {/* Wallet Address */}
                <p className="text-sm font-semibold" style={{ color: '#836FFF' }}>
                  0xfg...774hk
                </p>

                {/* Points with Star Icon */}
                <div className="flex items-center justify-center gap-1">
                  <span className="text-lg font-bold text-swapper-secondary">
                    12 456
                  </span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="#836FFF"
                    className="inline-block"
                  >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
